import type { common as pt } from '../pt-BR/common';
import type { Traducao } from '../Traducao';

export const common = {
  appName: 'My Update',
  yes: 'Sí',
  no: 'No',
  save: 'Guardar',
  cancel: 'Cancelar',
  loading: 'Cargando...',
  search: 'Buscar',
  searchPlaceholder: 'Escribe para buscar...',
  name: 'Nombre',
  status: 'Estado',
  updatedAt: 'Actualizado en',
  statuses: {
    active: 'Activo',
    inactive: 'Inactivo',
  },
  errors: {
    required: 'Campo obligatorio',
    invalidEmail: 'Correo no válido',
    network: 'Error de conexión. Inténtalo de nuevo.',
  },
  data: {
    dia: 'Día',
    mes: 'Mes',
    ano: 'Año',
    diaPlaceholder: 'dd',
    mesPlaceholder: 'mm',
    anoPlaceholder: 'aaaa',
  },
  nav: {
    sidebar: 'Barra lateral',
    inicio: 'Inicio',
    campanhas: 'Campañas',
    responder: 'Responder campaña',
    usuarios: 'Usuarios y perfiles',
    language: 'Idioma',
    theme: 'Tema',
    userMenu: 'Menú de usuario',
  },
  themes: {
    light: 'Claro',
    dark: 'Oscuro',
    system: 'Sistema',
  },
  notFound: {
    title: 'Página no encontrada',
    description: 'La página que buscas no existe o se ha movido.',
    back: 'Volver al inicio',
  },
  errorBoundary: {
    title: 'Algo salió mal',
    description: 'Ocurrió un error inesperado. Recarga la página e inténtalo de nuevo.',
    reload: 'Recargar',
  },
  tableFilters: {
    trigger: 'Filtrar por {{column}}',
    triggerActive: 'Filtrar por {{column}} (filtro aplicado)',
    title: 'Filtrar {{column}}',
    apply: 'Aplicar',
    clear: 'Limpiar',
    textPlaceholder: 'Contiene…',
    textInputLabel: 'Texto para filtrar {{column}}',
    optionsSearchPlaceholder: 'Buscar…',
    optionsSearchLabel: 'Buscar en {{column}}',
    optionsEmpty: 'No se encontró nada para "{{query}}".',
    min: 'Mínimo',
    max: 'Máximo',
  },
  close: 'Cerrar',
} as const satisfies Traducao<typeof pt>;
